import {useEffect, useState} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap';
import {BsWallet} from "react-icons/bs";
import {RiArrowDownSLine} from "react-icons/ri";
import {Link} from 'react-router-dom';
import {Home, Power} from 'react-feather';
import {connect, useDispatch} from 'react-redux';
import jwtDecode from "jwt-decode";
import {store} from "@store";
import {handleLogout} from "@store/actions/auth";
import DisplayPriceWithLabel from "@components/displayPriceWithLabel";
//import {Roles} from "@configs/panel/roles/ProjectRole";
//import Avatar from '@components/avatar'
//import defaultAvatar from '@src/assets/images/avatars/avatar-blank1.jpg'

const UserDropdown = (props) => {
    // ** Store Vars
    const dispatch = useDispatch()

    // ** State
    const [userData, setUserData] = useState(null)

    //** ComponentDidMount
    useEffect(() => {
        let token = localStorage.getItem('token');
        if (token) {
            try {
                setUserData(jwtDecode(token))
            } catch (e) {
                store.dispatch(handleLogout())
            }
        }

    }, [])

    //** Vars
    //const userAvatar = (userData && userData.avatar) || defaultAvatar

    //const profilePagePath = userData && userData.roles[0] === Roles.customer ? '/panel/user-info' : userData && userData.roles[0] === Roles.expert ? "/panel/expert-info" : userData && userData.roles[0] === Roles.Representative ? "/panel/representative-info" : "/";

    return (
        <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
            <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
                <RiArrowDownSLine/>
                <div className='user-nav'>
                    <span className='user-name font-weight-bold'>
                        {`${props.user.fullName}`}
                    </span>
                    {/*  <Badge color="primary">
                        {userData?.roles?.map((role, index) => (
                            <div key={index}>
                                <RoleLabel role={role}/>
                                {userData.roles.length - 1 > index ? " - " : null}
                            </div>
                        ))}
                    </Badge>*/}
                </div>
                {/*<Avatar img={userAvatar} imgHeight='40' imgWidth='40' status='online'/>*/}
            </DropdownToggle>
            <DropdownMenu right={false}>
                {/* {!((userData && userData.roles[0]) === Roles.admin) &&
                    < DropdownItem tag={Link} to={profilePagePath ? profilePagePath : "/"}><User size={14} className='mr-75'/>
                    <span className='align-middle'>اطلاعات کاربری</span>
                    </DropdownItem>
                }*/}
                {userData?.wallet_price > 0 &&
                    <div>
                        <DropdownItem header className="d-flex justify-content-between flex-column w-100 py-50 px-50">
                            <div className="mb-50">
                                <BsWallet size={14} className='mr-50'/>
                                <span>موجودی کیف پول</span>
                            </div>
                            <div className="text-right">
                                <DisplayPriceWithLabel
                                    price={props.wallet?.price}
                                    label="Toman"
                                    isLabelSmall
                                    isPriceBold
                                />
                            </div>
                        </DropdownItem>
                        <hr/>
                    </div>
                }
                <DropdownItem tag={Link} to='/'>
                    <Home size={14} className='mr-75'/>
                    <span className='align-middle'>وبسایت</span>
                </DropdownItem>
                <DropdownItem tag={Link} to='/' onClick={() => dispatch(handleLogout())}>
                    <Power size={14} className='mr-75'/>
                    <span className='align-middle'>خروج</span>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth,
        wallet: state.wallet
    }
};

export default connect(mapStateToProps, {handleLogout})(UserDropdown);